import { useMemo } from 'react';

export const useMemoizedFacets = (fieldFacets: string[]) => {
  const fieldFacetsHash = fieldFacets.join(','); // Join these together to create a "hash" for useMemo
  return useMemo(
    () =>
      fieldFacets.map((fieldFacet) => ({
        id: fieldFacet,
        name: fieldFacet,
      })),

    [fieldFacetsHash],
  );
};
